import React from 'react';

/*
  Shared page header for every authenticated route. Renders the xpnsr.tech
  display title block:

    [orange kicker rule + label]
    Big display title (with optional <em> for accent)
    // sub copy
                                                            [actions →]

  Use this instead of crafting a bespoke <h1> per page so all 17 routes
  share the same vertical rhythm and typography.

  Props:
    kicker   — optional small uppercase mono label above the title
    title    — string or JSX (use <em> for accent words)
    subtitle — optional small mono caption under the title
    actions  — optional right-aligned JSX (buttons, dropdowns, etc.)
*/

export default function XpnsrPageHeader({ kicker, title, subtitle, actions }) {
  return (
    <header className="xp-ph" data-testid="page-header">
      <div className="xp-ph-text">
        {kicker ? (
          <div className="xp-ph-kicker">
            <span className="xp-ph-kicker-rule" />
            {kicker}
          </div>
        ) : null}
        <h1>{title}</h1>
        {subtitle ? <p className="xp-sub">{subtitle}</p> : null}
      </div>
      {actions ? <div className="xp-ph-actions">{actions}</div> : null}
    </header>
  );
}
